<template>
  <div class="signup-container">
    <TopBar
      color="#000"
      :login="true"
      signUp="#0D53FF"
      loginColor="#A3AAB7"
      :imgsrc="logo1"
    />
    <div class="signup-img"></div>
    <div class="signup-content">
      <div class="content-input-box">
        <div class="title"><span>Hello!</span><span>欢迎新用户注册</span></div>

        <el-form
          :model="signupForm"
          :rules="rules"
          ref="signupForm"
          label-width="0px"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="signupForm.phone"
              placeholder="请输入手机号"
              size="large"
              clearable
            >
              <template slot="prefix">
                <i class="el-icon-mobile-phone"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="verifycode">
            <el-input
              v-model="signupForm.verifycode"
              placeholder="请输入验证码"
              :prefix-icon="verifycode"
              size="large"
              clearable
            >
              <template slot="prefix">
                <i class="iconfont icon-yanzhengma"></i>
              </template>
              <template slot="append">
                <el-button
                  @click="getVerifyCode"
                  :disabled="codeCountdown > 0"
                  style="width: 100px"
                >
                  {{ codeCountdown > 0 ? `${codeCountdown}s` : "获取验证码" }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="signupForm.password"
              type="password"
              placeholder="请输入登录密码"
              size="large"
              show-password
              @input="checkPasswordStrength"
            >
              <template slot="prefix">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
            <div class="password-strength" v-if="signupForm.password">
              <el-progress
                :percentage="passwordStrength.percentage"
                :color="passwordStrength.color"
                :show-text="false"
                :stroke-width="4"
              />
              <span
                class="strength-text"
                :style="{ color: passwordStrength.color }"
              >
                {{ passwordStrength.text }}
              </span>
            </div>
          </el-form-item>

          <el-form-item prop="confirmPassword">
            <el-input
              v-model="signupForm.confirmPassword"
              type="password"
              placeholder="请再次输入密码"
              size="large"
              show-password
            >
              <template slot="prefix">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="agreement">
            <el-checkbox v-model="signupForm.agreement">
              我已阅读并同意<a href="#" class="agreement-link">《用户协议》</a>
            </el-checkbox>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              size="large"
              @click="handleSignup"
              class="signup-btn"
              :loading="loading"
            >
              注册
            </el-button>
          </el-form-item>
        </el-form>

        <div class="routerpush">
          <div class="login-link">
            <p>已有账号？立即<span @click="goToLogin">登录</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { signUp, getCode } from "@/api/user";
import { Message } from "element-ui";
import TopBar from "@/views/supermarket/TopBar";
import logo1 from "@/assets1/logo_slices/编组 2.png";
import verifycode from "@/assets1/后台/ves.png";
import { Login } from "@/api/user";

export default {
  components: {
    TopBar,
  },
  data() {
    // 确认密码验证规则
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.signupForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneReg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    return {
      logo1,
      verifycode,
      loading: false,
      codeCountdown: 0,
      signupForm: {
        username: "",
        password: "",
        phone_token: "",
        confirmPassword: "",
        phone: "",
        verifycode: "",
        agreement: false,
      },
      passwordStrength: {
        percentage: 0,
        color: "#909399",
        text: "弱",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "用户名长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在 6 到 20 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [{ validator: validatePass, trigger: "blur" }],
        phone: [{ validator: validatePhone, trigger: "blur" }],
        verifycode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        agreement: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请同意用户协议"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    // 检查密码强度
    checkPasswordStrength() {
      const password = this.signupForm.password;
      let strength = 0;

      if (password.length >= 8) strength += 25;
      if (/[a-z]/.test(password)) strength += 25;
      if (/[A-Z]/.test(password)) strength += 25;
      if (/[0-9]/.test(password)) strength += 25;

      this.passwordStrength.percentage = strength;
      console.log(
        this.passwordStrength.percentage,
        "this.passwordStrength.percentage"
      );

      if (strength <= 25) {
        this.passwordStrength.color = "#F56C6C";
        this.passwordStrength.text = "弱";
      } else if (strength <= 50) {
        this.passwordStrength.color = "#E6A23C";
        this.passwordStrength.text = "中";
      } else if (strength <= 75) {
        this.passwordStrength.color = "#409EFF";
        this.passwordStrength.text = "强";
      } else {
        this.passwordStrength.color = "#67C23A";
        this.passwordStrength.text = "很强";
      }
    },

    // 获取验证码
    async getVerifyCode() {
      if (!this.signupForm.phone) {
        Message.error("请先输入手机号");
        return;
      }

      // 这里应该调用获取验证码的API
      const res = await getCode({
        phone: this.signupForm.phone,
        reason:'sign_up',
        mock:false
      });
      console.log(res, "res");
      this.signupForm.phone_token = res.phone_token;
      Message.success("验证码已发送");
      this.codeCountdown = 60;

      const timer = setInterval(() => {
        this.codeCountdown--;
        if (this.codeCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    // 处理注册
    handleSignup() {
      this.$refs.signupForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          console.log(this.signupForm, "this.signupForm");
          const res = await signUp({
            phone_token: this.signupForm.phone_token,
            phone: this.signupForm.phone,
            verification_code: this.signupForm.verifycode,
            password: this.signupForm.password,
          });
          // 这里应该调用注册API
          console.log(res, "res");
          this.loading = false;
          Message.success("注册成功！");
          // 注册成功后跳转到登录页面
          this.goToLogin();
        } else {
          Message.error("请检查输入信息");
          return false;
        }
      });
    },

    // 跳转到登录页面
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
::deep(.el-progress-bar__outer) {
  height: 10px !important;
}
:deep(.el-input-group__append > button) {
  color: #000 !important;

  background-color: #fff !important;
  /* border: none !important; */
}
:deep(.el-input-group__append > button > span) {
  border-left: 1px solid #d6dae2 !important;
  padding-left: 6px !important;
  /* border: none !important; */
}
::deep(.el-input-group__append) {
  border: none !important;
  background-color: #fff !important;
}

.icon-yanzhengma {
  font-size: 14px;
}
.verifycode-icon {
  width: 20px;
  height: 20px;
}
.signup-container {
  min-width: 1920px;
  height: 100vh;
  display: flex;
  font-family: Regular;
}

.signup-img {
  flex-shrink: 0;
  width: 38%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url("https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E7%99%BB%E5%BD%95%E9%A1%B5/Group%208.png");
}

.signup-content {
  flex-shrink: 0;
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-input-box {
  width: 400px;
}

.title {
  margin-bottom: 60px;
  text-align: center;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0.6px;
}

.title span:first-child {
  display: inline-block;
  width: 107px;
  font-family: Medium;
}

.title span {
  font-family: Medium;
}

.el-form-item {
  margin-bottom: 30px;
}

.el-input--large .el-input__inner {
  height: 50px;
  font-size: 16px;
  border: none;
  border-radius: 0;
  background: transparent;
}

.el-input--large .el-input__inner:focus {
  border: none;
}

.el-input--large {
  position: relative;
}

.el-input--large::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #d6dae2;
}

.el-input--large .el-input__prefix {
  left: 0;
  top: 0;
  height: 50px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-input--large .el-input__inner {
  padding-left: 50px;
}

.password-strength {
  margin-top: 8px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100;
  width: 100%;
  background: #fff;
  padding: 4px 0;
}

.password-strength .el-progress {
  flex: 1;
  margin-right: 10px;
}

.password-strength .el-progress .el-progress-bar {
  padding-right: 0 !important;
}

/* .password-strength .el-progress .el-progress-bar__outer {
  background-color: #f0f0f0 !important;
  border-radius: 2px !important;
  height: 10px !important;
} */

.password-strength .el-progress .el-progress-bar__inner {
  border-radius: 2px !important;
}

.strength-text {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
}

.signup-btn {
  width: 100%;
  height: 50px;
  background-color: #0d53ff;
  border: none;
  font-size: 18px;
  font-weight: 500;
  margin-top: 20px;
}

.signup-btn:hover {
  background-color: #0d53ff;
  opacity: 0.9;
}

.routerpush {
  margin-top: 20px;
  text-align: center;
}

.login-link {
  font-size: 14px;
  color: #999;
}

.login-link span {
  color: #0d53ff;
  cursor: pointer;
}

.login-link span:hover {
  text-decoration: underline;
}

.agreement-link {
  color: #0d53ff;
  text-decoration: none;
}

.agreement-link:hover {
  text-decoration: underline;
}

.el-checkbox__label {
  color: #666;
  font-size: 14px;
}

.el-progress-bar {
  padding-right: 0;
}

.el-input-group__append {
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-left: 0;
  border-radius: 0 4px 4px 0;
}

.el-input-group__append .el-button {
  border: none;
  background: transparent;
  color: #0d53ff;
  font-size: 14px;
}

.el-input-group__append .el-button:hover {
  color: #0d53ff;
  background: transparent;
}

.el-input-group__append .el-button.is-disabled {
  color: #c0c4cc;
}
</style>
<style>
.signup-content .el-progress-bar__outer {
  height: 10px !important;
}
.signup-content .el-input__inner {
  border: none;
  background: transparent !important;
  font-family: Regular;
}

.signup-content .el-input__inner::placeholder {
  padding-left: 5px;
  font-family: Regular;
  color: #cccccc !important;
}
.signup-content .el-input__inner:focus {
  background: transparent !important;
}
.signup-content .el-input__inner:hover {
  background: transparent !important;
}
.signup-content .el-input__inner:active {
  background: transparent !important;
}
.signup-content .el-input__prefix {
  color: #000 !important;
}
.signup-content .el-input-group__append {
  border: none !important;
  background-color: #fff !important;
  font-family: Regular !important;
  font-size: 14px !important;
  color: #3d4657 !important;
}

.signup-content .el-form-item {
  position: relative;
}

.signup-content .el-form-item__error {
  position: absolute !important;
  top: 50% !important;
  right: auto !important;
  transform: translateY(-50%) !important;
  left: 480px !important;
  bottom: auto !important;
  line-height: 1 !important;
  padding-top: 0 !important;
  margin-top: 0 !important;
  background: transparent !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  white-space: nowrap !important;
  z-index: 1000 !important;
  font-size: 12px !important;
}
</style>
